var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"fas fa-database"}),_vm._v(" THÔNG TIN CHUNG")]),_c('ThongTinChung')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }